<template>
  <div class="scroll-vertical full-height big-spacer related-groups">
    <div v-for="group in groups" :key="group.uid" class="spacer">
      <alert-log-group :group="group" :related="related"></alert-log-group>
    </div>
  </div>
</template>

<script>
import AlertLogGroup from '@/components/alertlogs/AlertLogGroup.vue';

export default {
  name: 'AlertRelatedGroups',
  components: {
    AlertLogGroup,
  },
  props: {
    groups: {
      type: Array,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.spacer {
  margin-bottom: 1rem;
}

.big-spacer {
  padding-bottom: 8rem;
}

.full-height {
  height: 100%;
}
</style>
